// extracted by mini-css-extract-plugin
module.exports = {"reason":"error-modal_reason__REKGU","errorSummaryContainer":"error-modal_errorSummaryContainer__2T4DI"};